<!-- 地图入口页面
 - type: 1 (首页-打点  || 农事-看地图)
 - type: 2 (画地块) 目前为功能预留
 - type: 3 (移动灌溉设备-设备定位)
 - type: 4 (电子围栏)
 - type: 5 (围栏报警-报警详情)
-->
<template>
    <div class="mainBox">
        <div class="mainContent">
            <template v-if="type == '1'">
                <Marking :config="config" />
            </template>
            <template v-else-if="type == '2'">
                <Plot :config="config" />
            </template>
            <template v-else-if="type == '3' || type == '5'">
                <DevicePositioning :config="config" :type="type" />
            </template>
            <template v-else-if="type == '4'">
                <ElectronicFence :config="config" />
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: "Maps",
    components: {
        Marking: () => import('./modules/marking.vue'), // 动态引入 设备打点页面
        Plot: () => import('./modules/plot.vue'), // 动态引入 画地块页面
        DevicePositioning: () => import('./modules/devicePositioning.vue'), // 动态引入 移动灌溉设备-设备定位页面 | 围栏报警-报警详情页面
        ElectronicFence: () => import('./modules/electronicFence.vue'), // 动态引入 电子围栏页面
    },
    data() {
        return {
            type: "", // 显示类型  1 设备打点  2 画地块  3 移动灌溉-设备定位  4 电子围栏  5 围栏报警-报警详情
            userId: "", // 用户🆔
            config: {}, // 其他配置参数 - 不同页面使用的不同参数
        }
    },
    mounted() {
        this.receiveFromUni();
    },
    methods: {
        /**
         * 解析uniapp传递过来的数据
         * 必要参数: type(区分使用什么组件), token(接口请求使用), locales(国际化使用), userId(用户操作权限使用)
         */
        receiveFromUni() {
            const urlParams = new URLSearchParams(window.location.search);
            const type = urlParams.get("type") || "1"; // 显示类型  1 设备打点  2 画地块  3 移动灌溉-设备定位  4 电子围栏  5 围栏报警-报警详情
            const token = urlParams.get("token") || "";
            const locales = urlParams.get("locales") || "zh-CN"; // 国际化
            const userId = urlParams.get("userId") || "";
            this.type = type;
            localStorage.setItem("token", token);
            this.$i18n.locale = locales;
            this.userId = userId || "";
            if (this.userId) {
                this.getRole();
            }
            const config = urlParams.get("config") ? JSON.parse(urlParams.get("config")) : {};
            this.config = {...config, userId: this.userId};
            console.log("config", config);
            
            this.changePageTitle(type);
        },
        /**
         * 获取用户权限字符集
         */
        async getRole() {
            try {
                const res = await this.$api.getRoleByUserId(this.userId);
                if (res.code != "200") {
                    this.$toast.clear();
                    this.$toast.fail(res.msg);
                } else {
                    this.$store.commit("SET_ROLE", [res.msg] || []);
                }
            } catch (error) {
                console.error("错误", error);
            }
        },
        changePageTitle(type) {
            if (type == '1') {
                if (this.config?.operationType == "marking") {
                    document.title = this.$t('title.marking');
                } else {
                    document.title = this.$t('title.map');
                }
            } else if (type == '2') {
                document.title = this.$t('title.plot');
            } else if (type == '3') {
                document.title = this.$t('title.devicePositioning');
            } else if (type == '4') {
                document.title = this.$t('title.electronicFence');
            } else if (type == '5') {
                document.title = this.$t('title.warningDetails');
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.mainBox {
    width: 100%;
    height: 100vh;
    padding: 0 10px 20px;
    box-sizing: border-box;
    background: linear-gradient(167deg,
            rgba(42, 130, 228, 1) 0%,
            rgba(255, 255, 255, 1) 100%);
    background-repeat: repeat;
    background-size: normal;
    display: flex;
    flex-direction: column;

    .mainContent {
        margin-top: 30px;
        width: 100%;
        height: 0;
        flex: 1;
        border-radius: 24px 24px 0 0;
        overflow: hidden;
        background: rgba(242, 242, 242, 1);
        border: 1px solid rgba(242, 242, 242, 1);
        backdrop-filter: blur(12px);
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }
}
</style>
<style>
.commonBox {
    width: 100%;
    height: 100%;
}
</style>